import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { getRoutePath } from '@/shared/utils/routes';

import { Props } from './types';

export const HomePage: FC<Props> = () => {
  return <Navigate to={getRoutePath('MAIN', 'CHANNELS')} />;
};
